<template>
  <ul class="day-list">
    <li class="day-list-item" @click="sortbydays(30)">
      30 Days
    </li>
    <li class="day-list-item" @click="sortbydays(60)">
      60 Days
    </li>
    <li class="day-list-item" @click="sortbydays(90)">
      90 Days
    </li>
    <li class="day-list-item" @click="sortbydays(1)">
      Q1
    </li>
    <li class="day-list-item" @click="sortbydays(2)">
      Q2
    </li>
    <li class="day-list-item" @click="sortbydays(3)">
      Q3
    </li>
    <li class="day-list-item" @click="sortbydays(4)">
     Q4
    </li>
    <li class="day-list-item" @click="sortbydays(5)">
     YTD
    </li>
    <li class="day-list-item" @click="sortbydays(0)">
      All
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: "FilterDays",
    computed: {
      ...mapGetters(["getComponentNum"])
    },
    methods: {
      ...mapActions(['setDaysFilter','setComponentNum','setOverDueStatus','overDues','sendSearchReq','getPendingInfoList','getWooOrders','setAdminPginationPage','getAnalyticsInfoList','sendSearchReqAnalytics', 'resetState']),
      async sortbydays(val) {
          this.resetState();
          await this.setDaysFilter(val);
          this.$emit("title", { show: false, value: val });
          if(this.$store.getters.getOverDueStatus) {
              this.setComponentNum(0);
              this.setOverDueStatus(null);
          }
          if(this.$store.getters.getComponentNum == 4) {
              this.getPendingInfoList();
          } else if(this.$store.getters.getComponentNum == 11) { 
              this.getWooOrders();
          } else if(this.$store.getters.getComponentNum == 3) { 
            this.sendSearchReqAnalytics();
            this.sendSearchReqAnalyticsAll();
            if(this.$store.getters.getShowAnaltics) { 
              this.setAdminPginationPage(null).then(() => {
                const data = this.$store.getters.getAnalyticsFilter;
                this.getAnalyticsInfoList(data);
              });
            }
          } else {
              this.sendSearchReq();
          } 
          await this.overDues();
      }
    }
}
</script>

<style scoped>
.day-list {
  position: absolute;
background-color: #fff;
width: 86px;
left: 13px;
z-index: 2;
margin-top: 323px;
border: 1px solid #e7ecef;
  border-top-color: rgb(230, 236, 240);
  border-top-style: solid;
  border-top-width: 2px;
border-radius: 5px;
border-top: 0px
}
.day-list-item {
  font-size: 13px;
  font-family: TTNormsLight, sans-serif;
  width: 100%;
  padding: 10px 16px;
  cursor: pointer;
  color: #000;
  text-align: left;
}
.day-list-item:hover {
  background-color:  rgb(198, 195, 195);  
}
</style>
